import { render, staticRenderFns } from "./allnotification.vue?vue&type=template&id=42133554"
import script from "./allnotification.vue?vue&type=script&lang=js"
export * from "./allnotification.vue?vue&type=script&lang=js"
import style0 from "./allnotification.vue?vue&type=style&index=0&id=42133554&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports